// client/src/components/admin/influencer/InfluencerContractPendingListRead.js
import React, { useEffect, useState } from 'react';
import '../../../styles/admin/AdminTable.css';

const API_URL = process.env.REACT_APP_API_URL;

function InfluencerContractPendingListRead({
  onSelect,
  selectedId,
  interactive = true,
  refreshToken,
  showSearch = true
}) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  // 검색 입력값과 적용된 필터 분리(검색 버튼 눌렀을 때만 반영)
  const [filters, setFilters] = useState({
    userId: '',
    userName: '',
    phoneNumber: '',
    email: '',
    userAddress: ''
  });
  const [applied, setApplied] = useState({
    userId: '',
    userName: '',
    phoneNumber: '',
    email: '',
    userAddress: ''
  });

  const fetchList = async (p = 1, q = {}) => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({ page: String(p), limit: '50' });
      ['userId', 'userName', 'phoneNumber', 'email', 'userAddress'].forEach((k) => {
        const v = q[k];
        if (v && String(v).trim()) params.append(k, String(v).trim());
      });

      const res = await fetch(`${API_URL}/api/influencer/contract-pending-read?${params.toString()}`, {
        credentials: 'include'
      });
      if (res.status === 401) {
        setError('관리자 세션이 만료되었습니다. 다시 로그인하세요.');
        setItems([]);
        return;
      }
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || '불러오기 실패');
      setItems(data.items || []);
    } catch (e) {
      setError(e.message || '불러오기 실패');
    }
    setLoading(false);
  };

  // 초기 / 갱신 시 현재 applied 조건으로 서버 재조회
  useEffect(() => { fetchList(1, applied); }, [refreshToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const applySearch = () => {
    const next = { ...filters };
    setApplied(next);
    fetchList(1, next);
  };

  const resetSearch = () => {
    const empty = { userId: '', userName: '', phoneNumber: '', email: '', userAddress: '' };
    setFilters(empty);
    setApplied(empty);
    fetchList(1, empty);
  };

  const fmt = (d) => {
    try { return new Date(d).toLocaleString(); } catch { return d || ''; }
  };

  return (
    <div className="admin-list">
      <div className="admin-list__header">위촉 계약 대기 목록</div>

      {/* 검색 영역 */}
      {showSearch && (
        <div className="admin-list__search">
          <div className="admin-list__search-grid">
            <input
              placeholder="아이디"
              value={filters.userId}
              onChange={(e) => setFilters(v => ({ ...v, userId: e.target.value }))}
              className="admin-list__search-input"
            />
            <input
              placeholder="이름"
              value={filters.userName}
              onChange={(e) => setFilters(v => ({ ...v, userName: e.target.value }))}
              className="admin-list__search-input"
            />
            <input
              placeholder="전화번호"
              value={filters.phoneNumber}
              onChange={(e) => setFilters(v => ({ ...v, phoneNumber: e.target.value }))}
              className="admin-list__search-input"
            />
            <input
              placeholder="메일"
              value={filters.email}
              onChange={(e) => setFilters(v => ({ ...v, email: e.target.value }))}
              className="admin-list__search-input"
            />
            <input
              placeholder="주소"
              value={filters.userAddress}
              onChange={(e) => setFilters(v => ({ ...v, userAddress: e.target.value }))}
              className="admin-list__search-input admin-list__search-input--full"
            />
          </div>
          <div className="admin-list__search-actions">
            <button 
              type="button" 
              onClick={resetSearch}
              className="admin-list__search-button"
            >
              초기화
            </button>
            <button 
              type="button" 
              onClick={applySearch}
              className="admin-list__search-button admin-list__search-button--primary"
            >
              검색
            </button>
          </div>
        </div>
      )}

      <div className="admin-list__body admin-list__body--fixed-height">
        {error && <div className="admin-list__error">{error}</div>}
        {loading && <div className="admin-list__loading">불러오는 중...</div>}
        {!loading && items.length === 0 && !error && (
          <div className="admin-list__empty">목록이 없습니다.</div>
        )}

        {!loading && items.length > 0 && (
          <div>
            {items.map((u) => (
              <div
                key={u._id || u.userId}
                onClick={interactive && onSelect ? () => onSelect(u) : undefined}
                className={`admin-list__item ${
                  selectedId && (selectedId === (u._id || u.userId)) ? 'admin-list__item--selected' : ''
                }`}
                style={{ cursor: interactive ? 'pointer' : 'default' }}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {u.userId} ({u.userName})
                  </div>
                  <div className="admin-list__item-sub">{fmt(u?.contractMail?.lastSentAt)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InfluencerContractPendingListRead;
